export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10224.7ca4f46d.jpg";